/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import Search from "../../images/icons/search.svg";
import { useStateValue } from "../../context/store";
import { headers } from "./models";
import ModalConfirmBaseComment from "../../utils/form/modalConfirmBaseComment";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import { Backdrop, CircularProgress, Typography } from "@material-ui/core";
import Utils from "../../utils/utils";
import { getMaestras } from "../../actions/maestras-actions";
import {
  cancelMaternityLicenceAsync,
  getFilterMaternityLicence,
} from "../../actions/licence-motherhood-actions";
import {
  cancelRefundByRecomendationAsync,
  finishRefundByRecomendationAsync,
  getFilterRefundRecomendation,
} from "../../actions/refund-recommendation-actions";
import RefundSearch from "../../componentes/refundRecomendationsAt/refundSearch";
import RefundAccordion from "../../componentes/refundRecomendationsAt/refundAccordion";
import { permissionsConstans } from "../../constansPermissions";
const _ = require("lodash");

const RefundRecomendationsAt = (props) => {
  const [{ filterRefundByRecomendation, breadCrumb }, dispatch] =
    useStateValue();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState({
    open: false,
    description: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    oneButtons: false,
    type: "",
  });
  const [maestras, setMaestras] = useState({
    estadoCivil: [],
    generos: [],
    nivelFormacion: [],
    respuestaAfirmacionNegacion: [],
    tallaCalzado: [],
    tallaLetras: [],
    tallaNumerosFemenino: [],
    tallaNumerosMasculino: [],
    tipoDocumnetoIdentificacion: [],
  });

  const getListaMaestras = async () => {
    const response = await getMaestras();
    setMaestras(response.data.maestras);
    return response.data.maestras;
  };

  useEffect(() => {
    getListaMaestras();
  }, []);

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
    isCommentRequired: false,
  });

  const [filter, setFilter] = useState({
    employeeName: null,
    employeeSurname: null,
    initDate: null,
    endDate: null,
    regional: null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const { path } = useRouteMatch();

  const getRefunds = async () => {
    var d = new Date();
    d.setHours(0, 0, 0, 0);

    var initDate = filter.initDate
      ? Utils.getFormattedDateyyyyMMdd(filter.initDate, "-")
      : null;
    const response = await getFilterRefundRecomendation(
      {
        initDate: initDate,
        endDate: filter.endDate
          ? filter.endDate.toISOString().split("T")[0]
          : d.toISOString().split("T")[0],
        regionalId: filter.regional === "" ? null : filter.regional,
        regionalName: null,
        employeeName: filter.employeeName === "" ? null : filter.employeeName,
        employeeSurname:
          filter.employeeSurname === "" ? null : filter.employeeSurname,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response.data) {
      const data = response.data.refundPage;
      if (data.content?.length > 0) {
        setPaginadorResponse({
          data: data.content,
          totalRows: data.totalElements,
          pageSize: data.size,
          pageNumber: data.number,
        });
      } else {
        setPaginadorResponse({
          data: [],
          totalRows: 0,
          pageSize: 0,
          pageNumber: 0,
        });
      }
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  if (breadCrumb?.isCreateRefundStartProcess) {
    setTimeout(() => {
      props.history.push(`${path}/crear`);
    }, 100);
  }

  useEffect(() => {
    getRefunds();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Reintegro por recomendaciones AT",
      breadCrumbSubText: "Reintegro por recomendaciones AT",
      index: 41,
    });
  }, [paginadorRequest]);

  if (
    filterRefundByRecomendation &&
    filterRefundByRecomendation?.isFilter &&
    filter !== filterRefundByRecomendation.filter
  ) {
    var newfilter = filterRefundByRecomendation.filter;
    filter.initDate = newfilter.initDate;
    filter.endDate = newfilter.endDate;
    filter.employeeName = newfilter.employeeName;
    filter.employeeSurname = newfilter.employeeSurname;
    filter.regional = newfilter.regional;
    paginadorRequest.page = 0;
    getRefunds();
    dispatch({
      type: "SET_FILTER_REFUND",
      isFilter: false,
    });
  }

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
    }));
  };

  const closeMessage = () => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const handleCancelRefund = async (id) => {
    closeModal();
    const response = await cancelRefundByRecomendationAsync(id);
    if (response && (response?.status === 200 || response?.status === 201)) {
      setMessage({
        description: `Registro de ingreso por recomendaciones AT Anulado.`,
        textButtonSubmit: "Volver",
        handleClick: () => closeMessage(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      getRefunds();
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error
          ? response?.data?.error
          : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => closeMessage(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => closeMessage(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const handleFinalizeRefund = async (comm, id) => {
    closeModal();
    const response = await finishRefundByRecomendationAsync({
      observation: comm,
      refundId: id,
    });
    if (response && (response?.status === 200 || response?.status === 201)) {
      setMessage({
        description: `Registro de reintegro por recomendaciones AT Finalizada.`,
        textButtonSubmit: "Volver",
        handleClick: () => closeMessage(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      getRefunds();
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.sattus !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : response?.data?.error
          ? response?.data?.error
          : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => closeMessage(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => closeMessage(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const onCancel = (id) => {
    setMessage(() => ({
      type: "QUESTION",
      open: true,
      description:
        "¿Está seguro que desea anular este registro por recomendaciones AT?",
      handleClick: () => handleCancelRefund(id),
      handleClickOut: closeMessage,
      buttonOneText: "ACEPTAR",
      oneButtons: false,
    }));
  };

  const onFinalize = (id) => {
    setConfirm(() => ({
      open: true,
      question:
        "¿Está seguro que desea finalizar este registro por recomendaciones AT?",
      handleClick: (comm) => handleFinalizeRefund(comm, id),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: false,
    }));
  };

  const validationPermissionSearch = () => {
    const state = JSON.parse(localStorage.getItem("state"));
    const module = state?.permissions.find((x) => x.code === "REF_REC");
    if (
      module?.functionalities?.some(
        (x) => x === permissionsConstans.REF_REC_CONSULTAR
      )
    ) {
      return <RefundSearch />;
    }
  };

  return (
    <div style={{ marginTop: "25px" }}>
      <ModalConfirmBase
        open={message.open}
        description={message.description}
        handleClickOut={message.handleClickOut}
        handleClick={message.handleClick}
        oneButtons={message.oneButtons}
        textButtonSubmit={message.buttonOneText}
        type={message.type}
      />
      <ModalConfirmBaseComment
        open={confirm.open}
        description={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
        textButtonSubmit={confirm.buttonOneText}
        type="QUESTION"
        isCommentRequired={confirm.isCommentRequired}
        isRefundRecomendations={true}
      />

      {validationPermissionSearch()}

      {paginadorResponse.data.map((row, index) => (
        <RefundAccordion
          headers={headers}
          data={row}
          handleCancel={onCancel}
          handleFinalize={onFinalize}
          maestras={maestras}
        />
      ))}
      {paginadorResponse.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
          labelRowsPerPage="Registros por página"
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
      <Backdrop style={{ zIndex: "9999" }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default withRouter(RefundRecomendationsAt);
